/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchremoved2Inputs */

const en_menulunchremoved2 = /** @type {(inputs: Menulunchremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch menu removed`)
};

const de_menulunchremoved2 = /** @type {(inputs: Menulunchremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü entfernt`)
};

/**
* | output |
* | --- |
* | "Lunch menu removed" |
*
* @param {Menulunchremoved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchremoved2 = /** @type {((inputs?: Menulunchremoved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchremoved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchremoved2(inputs)
	return de_menulunchremoved2(inputs)
});
export { menulunchremoved2 as "menuLunchRemoved" }